import React from 'react';
import {renderToString} from 'react-dom/server';

import TableOfContents from '@Themes/natucare/modules/Article/components/TableOfContents/TableOfContents';

const replaceTOC = (tocLinks) => renderToString(<TableOfContents heading='Spis treści' links={tocLinks}/>);

export default replaceTOC;
